import { render, staticRenderFns } from "./PostalcodeTown.vue?vue&type=template&id=91a76280&"
import script from "./PostalcodeTown.vue?vue&type=script&lang=js&"
export * from "./PostalcodeTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports